import AOS from 'aos';
import "aos/dist/aos.css";
import React, { useEffect } from 'react';

const UperFooter = ({ data }) => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);
  return (
    <div class='mt-3' style={{ background: 'linear-gradient(#fff 50%, #28282b 0)' }}>
      <div data-aos="zoom-in" class='col-11 m-auto p-2' style={{ background: '#f47024', color: 'white' }}>
        <div class='col-11 my-2 m-auto row align-items-center justify-content-between'>
          <div class='col-lg-5  text-start'>
            <p class='fs-3'>{data.title} <span class='fw-bold'>{data.highlight}</span> </p>
          </div>
          <div class='col-lg-5 '>
            <div class='row align-items-center justify-content-end gap-sm-0 gap-3'>
              <div class='col-sm-6 text-end'>
                <input type="text" class='form-control rounded-0 border border-1 plaseHolder' style={{ background: 'none' }} placeholder={data.inputPlaceholder} />
              </div>
              <div class='col-sm-6 text-sm-start text-end'>
                <button className="btn btn-outline-light rounded-0 border-1"> {data.buttonText}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default UperFooter